module.exports = __webpack_public_path__ + "img/undraw_empty_xct9.8b2a7ddf.svg";